var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"data":_vm.data,"onManager":_vm.onManager,"status-module":"cloudgroupcache","is-edit-name":false,"show-desc":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }